import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logOut, LogOutModalView, restoreModalView, setSidebarExpand } from '../../../actions/uiAction';
import { getSettingsData } from '../../../actions/subscriptionAction';
import { clearClickedFolder, listDocument, documentSearch, clearSearchData } from '../../../actions/documentAction';
import { openPopupWidget } from 'react-calendly';
import './caredailySidebar.css'; // Import the CSS file
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import routes from '../../../routes';

const CareSidebar = (props) => {
   const history = useHistory();
   const location = useLocation();
   const dispatch = useDispatch();

   const settingsData = useSelector((state) => state.subscriptionData.settingData);
   const expanded = useSelector((state) => state.UIReducer.sideBarExpanded);
   const active_subs = useSelector((state) => state.userLoginData.active_subs);
   const employeeSubscription = useSelector((state) => state.userLoginData.employeeSubscription);
   const userDetails = useSelector((state) => state.myProfile.addViewData);
   const companyData = useSelector((state) => state.UIReducer.userDetails);
   const docUpdateStatus = useSelector((state) => state.userLoginData.docUpdateStatus);
   const licenseStatus = useSelector((state) => state.userLoginData.licenseStatus);
   const userHavelicense = useSelector((state) => state.userLoginData.userHavelicense);

   const [showCareSection, setShowCareSection] = useState(false);
   const [setShowallInOne, setShowallInOneSection] = useState(false);


   useEffect(() => {
      if (userDetails && userDetails._id) {
         const subscription = userDetails?.subscription_data?.subscription_plan;
         const ManualsubscriptionAllinOne = userDetails?.allinOne?.status === 1 ? true : false;
         const ManualsubscriptionCareManagement = userDetails?.careManagement?.status === 1 ? true : false;

         if (subscription?.includes('allinone') || ManualsubscriptionAllinOne) {
            // setShowCareSection(true);
            setShowallInOneSection(true);
         } else if (subscription?.includes('caremanagement') || ManualsubscriptionCareManagement) {
            setShowCareSection(true);
         }
      }
   }, [userDetails]);

   const [expandedMenus, setExpandedMenus] = useState({});
   const [isSettingsOpen, setIsSettingsOpen] = useState(false);
   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
   const [dropdownOpen, setDropdownOpen] = useState(false);
   let pathname = props.location.pathname;
   const routeAccess = routes.find((i) => i.path === pathname && i.private);

   const restore_modal_view = () => {
      dispatch(restoreModalView());
      setDropdownOpen(false);
   };

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (dropdownOpen && !event.target.closest('.care-user-profile')) {
            setDropdownOpen(false);
         }
      };

      document.addEventListener('click', handleClickOutside);
      return () => {
         document.removeEventListener('click', handleClickOutside);
      };
   }, [dropdownOpen]);

   const profileToggle = () => {
      let tab = sessionStorage.getItem('sideBarSiteExpanded');
      tab && tab === 'true' && setDropdownOpen(!dropdownOpen);
   };

   const subscriptionList = () => {
      history.push('/subscriptions');
      setDropdownOpen(false);
   };

   const gotoPublicDocument = () => {
      history.push('/publishedpolicies');
      setDropdownOpen(false);
   };

   const getLongName = () => {
      if (userDetails?.firstname && userDetails?.lastname) {
         return `${userDetails.firstname} ${userDetails.lastname}`;
      }
      if (userDetails?.username) {
         return userDetails.username;
      }
      if (userDetails?.companyName) {
         return userDetails.companyName;
      }
      return 'User';
   };

   const userRole = sessionStorage.getItem('userRole');

   const user_permission = sessionStorage.getItem('user_permission') ? JSON.parse(sessionStorage.getItem('user_permission')) : [];

   useEffect(() => {
      dispatch(getSettingsData());
      const savedState = sessionStorage.getItem('sideBarSiteExpanded');
      const saved = sessionStorage.getItem('sideBarSiteExpanded'); // "true" | "false" | null
      const initialExpanded = saved === null ? Boolean(expanded) : saved === 'true';
      dispatch(setSidebarExpand(initialExpanded));
      setSidebarCollapsed(!initialExpanded);
      sessionStorage.setItem('sideBarSiteExpanded', String(initialExpanded));
   }, [dispatch]);

   useEffect(() => {
      if (typeof expanded !== 'boolean') return;
      setSidebarCollapsed(!expanded);
      sessionStorage.setItem('sideBarSiteExpanded', String(expanded));
   }, [expanded]);

   const handleNavigation = (path) => {
      if (location.pathname !== path) {
         // dispatch(documentSearch(null));
         // dispatch(clearSearchData(null));

         if (location.pathname === '/documents' || path === '/documents') {
            // dispatch(documentSearch(''));
            // dispatch(clearSearchData(null));
            // dispatch(clearClickedFolder());
            sessionStorage.removeItem('clickedFolderId');
            sessionStorage.removeItem('clickedFolderUid');
            sessionStorage.removeItem('clickedFolder');
            // dispatch(listDocument('name', false));
         }

         if (path === '/dashboard' || path === '/users' || path === '/index') {
            // dispatch(documentSearch(null));
            // dispatch(clearSearchData(null));
         }

         if (path !== '/myfiles' && path !== '/myfiles/editor') {
            sessionStorage.removeItem('myfilesSelectedFolderId');
            sessionStorage.removeItem('myfilesId');
         }

         if (path !== '/myDocuments' && path !== '/myDocuments/editor') {
            sessionStorage.removeItem('myfilesSelectedFolderId');
            sessionStorage.removeItem('myfilesId');
         }

         history.push(path);
      }
   };

   const toggleSubmenu = (menuKey) => {
      setExpandedMenus((prev) => ({
         ...prev,
         [menuKey]: !prev[menuKey],
      }));
   };

   const toggleSidebar = () => {
      const newState = !sidebarCollapsed;
      setSidebarCollapsed(newState);
      sessionStorage.setItem('sideBarSiteExpanded', !newState);
      dispatch(setSidebarExpand(!newState));
      // Update right content area
      const querySelector = document.querySelector('.right-sec-cnt');
      if (newState) {
         querySelector.classList.add('right-collapsed');
      } else {
         querySelector.classList.remove('right-collapsed');
      }
   };

   const myProfilefun = (type) => {
      props.history.push('/profile');
      sessionStorage.setItem('profileType', type);
      dispatch(LogOutModalView(props));
      setDropdownOpen(false);
   };

   const company_settings = () => {
      history.push('/settings');
      setIsSettingsOpen(false);
      setDropdownOpen(false);
   };

   const openTraining = () => {
      openPopupWidget({
         url: 'https://calendly.com/d/djv-dvw-6px/cloudoc-system-training',
         prefill: {},
         pageSettings: {
            backgroundColor: 'ffffff',
            hideEventTypeDetails: false,
            hideLandingPageDetails: false,
            primaryColor: '00a2ff',
            textColor: '4d5055',
         },
         utm: {},
      });
   };

   const hasPermission = (permissionName) => {
      if (userRole === 'company') return true;
      if (userRole === 'employee' && permissionName === 'Staff Policies') return true;
      if (user_permission.some((p) => p.name === permissionName)) return true;
      // return user_permission.some((p) => p.name === permissionName);
      // return user_permission.some((p) => p.name === permissionName || p.name === 'Manage users' || p.name === 'Manage employee');

   };



   const showProFeature = () => {
      return companyData?.proPackage?.status === 1 && String(active_subs) !== 'false';
   };
   const showTrainingButton = () => {
      return userDetails?.createdAt && new Date(userDetails.createdAt).setDate(new Date(userDetails.createdAt).getDate() + 30) > new Date();
   };

   const isActive = (path) => {
      return location.pathname === path;
   };

   const getUserInitials = () => {
      if (userDetails?.firstname) {
         return userDetails.firstname
            .split(' ')
            .map((n) => n[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
      }
      return 'U';
   };

   const getUserRole = () => {
      if (userRole === 'company') return 'Administrator';
      if (userRole === 'user') return 'Manager';
      if (userRole === 'employee') return 'Employee';
      return 'User';
   };

   const getCompanyLogo = () => {
      if (companyData?.companyDetails?.logoPath) {
         let logoPath = companyData.companyDetails.logoPath;
         if (logoPath.includes('https://www.caredocuments.co.uk/')) {
            logoPath = logoPath.replace('https://www.caredocuments.co.uk/', 'https://www.caredaily.co.uk/');
         }
         return logoPath;
      }
      if (companyData?.companyLogo) return companyData.companyLogo;
      if (companyData?.docLogoPath) return companyData.docLogoPath;
      if (settingsData?.admin_logo) return settingsData.admin_logo;
      return process.env.PUBLIC_URL + '/assets/images/logo.png';
   };

   const showPublicPolicies = () => {
      return (
         userRole === 'company' &&
         companyData?.settings?.showPoliciesonSite &&
         (companyData?.comboPackage?.status === 1 ||
            companyData?.documentManagement?.status === 1 ||
            companyData?.documentUpdate?.status === 1 ||
            companyData?.proPackage?.status === 1)
      );
   };
   // console.log(showPublicPolicies(),'showPublicPolicies')
   // Show sidebar on these pages
   const allowedSidebarPaths = [
      '/documents',
      '/dashboard',
      '/subscriptions',
      '/users',
      '/course',
      '/formslist',
      '/formbuilder',
      '/webform',
      '/users/add',
      '/users/edit',
      '/users/view',
      '/users/activity',
      '/saved-documents',
      '/create-new-documents',
      '/users/deleted-list',
      '/subscription/pay',
      '/documents/compare',
      '/index',
      '/documents/recent-updates',
      '/documents/need-review',
      '/documents/uptodate',
      '/documents/editor',
      '/settings',
      '/document/management/renewal',
      '/invoice',
      '/groups',
      '/group/add',
      '/group/edit',
      '/group/view',
      '/policies',
      '/policies/edit',
      '/policies/create',
      '/employees',
      '/policies/multi/create',
      '/employee/add',
      '/employee/edit',
      '/employee/view',
      '/deleted/employees',
      '/myfiles',
      '/myfiles/editor',
      '/myfiles/details',
      '/myDocuments',
      '/myDocuments/editor',
      '/myDocuments/details',
      '/publishedpolicies',
      '/deleted-documents',
      '/staff',
      '/recruitment',
      '/timesheet',
      '/payroll',
      '/time-sheets',
      '/supervision',
      '/compliance',
      '/clients',
      '/visits',
      '/policy-documents',
      '/careplans',
      '/daily-logs',
      '/medication',
      '/route-planning',
      '/billing',
      '/financial-reports',
      '/payments',
      '/outcomes',
      '/incidents',
      '/budgets',
      '/expense',
      '/contracts',
      '/messages',
      '/announcements',
      '/notifications',
      '/quality-audits',
      '/risk-register',
   ];

   // If this route is allowed but missing, add it:
   if (routeAccess?.hasSidebar) {
      allowedSidebarPaths.push(props.location.pathname);
   }

   const showSidebar = allowedSidebarPaths.some((path) => location.pathname === path);

   if (!showSidebar) return null;

   return (
      <nav className={`care-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
         {/* Toggle Button */}
         <button className={`care-sidebar-toggle ${sidebarCollapsed ? 'collapsed' : ''}`} onClick={toggleSidebar}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
               <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
         </button>

         {/* Logo */}
         {/* <div className="care-logo-container">
            <Link to="/dashboard" className="care-logo">
               <div className="care-logo-icon">C</div>
               <span>Care Daily</span>
            </Link>
         </div> */}
         {/* Logo */}
         {!sidebarCollapsed ? (
            <div className="care-logo-container">
               <Link to="/dashboard" className="care-logo">
                  <img
                     src={
                        companyData && companyData.companyDetails && companyData.companyDetails.logoPath
                           ? companyData.companyDetails.logoPath.includes('https://www.caredocuments.co.uk/')
                              ? companyData.companyDetails.logoPath.replace('https://www.caredocuments.co.uk/', 'https://www.caredaily.co.uk/')
                              : companyData.companyDetails.logoPath
                           : companyData && companyData.companyLogo
                              ? companyData.companyLogo
                              : companyData && companyData.docLogoPath
                                 ? companyData.docLogoPath
                                 : settingsData && settingsData.admin_logo
                                    ? settingsData.admin_logo
                                    : process.env.PUBLIC_URL + '/assets/images/site-logo.png'
                     }
                     alt="Company Logo"
                     style={{ maxHeight: '100px', maxWidth: '150px', objectFit: 'contain', margin: 'auto' }}
                     onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = process.env.PUBLIC_URL + '/assets/images/logo.png';
                     }}
                  />
               </Link>
            </div>
         ) : (
            <div className="care-logo-container" style={{ borderBottom: 'none' }}></div>
         )}

         {/* Quick Action Button */}
         {(showCareSection || setShowallInOne) && userRole === ('company' || 'user') && (
            <button className="care-quick-action" onClick={() => handleNavigation('/clients/add')}>
               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
               </svg>
               <span>New Client</span>
            </button>
         )}

         {/* Navigation */}
         <div className="care-nav-container">
            {hasPermission('Dashboard') && (
               <div className="care-nav-section">
                  <div className={`care-nav-item ${isActive('/dashboard') ? 'active' : ''}`} onClick={() => handleNavigation('/dashboard')}>
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="7" height="7"></rect>
                        <rect x="14" y="3" width="7" height="7"></rect>
                        <rect x="14" y="14" width="7" height="7"></rect>
                        <rect x="3" y="14" width="7" height="7"></rect>
                     </svg>
                     <span>Dashboard</span>
                  </div>
               </div>
            )}

            {/* Care Management Section */}
            {(showCareSection || setShowallInOne || userRole === 'user') && (
               <div className="care-nav-section">
                  {(hasPermission('Visit Scheduling') || hasPermission('Clients') || hasPermission('Careplan') || hasPermission('DailyLogs') || hasPermission('MedicationEmar') || hasPermission('Outcomes') || hasPermission('IncidentAlerts')) && (
                     <div className="care-section-header">Care Management</div>
                  )}


                  {/* {hasPermission('Dashboard') && (
                  <div
                     className={`care-nav-item ${isActive('/dashboard') ? 'active' : ''}`}
                     onClick={() => handleNavigation('/dashboard')}
                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="7" height="7"></rect>
                        <rect x="14" y="3" width="7" height="7"></rect>
                        <rect x="14" y="14" width="7" height="7"></rect>
                        <rect x="3" y="14" width="7" height="7"></rect>
                     </svg>
                     <span>Dashboard</span>
                  </div>
               )} */}

                  {/* Visits & Roster */}
                  {hasPermission('Visit Scheduling') && (
                     <div className={`care-nav-item ${isActive('/visits') ? 'active' : ''}`} onClick={() => handleNavigation('/visits')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                           <line x1="16" y1="2" x2="16" y2="6"></line>
                           <line x1="8" y1="2" x2="8" y2="6"></line>
                           <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        <span>Visits & Roster</span>
                     </div>
                  )}

                  {/* Service Users (Clients) */}
                  {hasPermission('Clients') && (
                     <div className={`care-nav-item ${isActive('/clients') ? 'active' : ''}`} onClick={() => handleNavigation('/clients')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                           <circle cx="9" cy="7" r="4"></circle>
                           <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                           <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        <span>Clients</span>
                     </div>
                  )}

                  {/* Care Plans */}
                  {hasPermission('Careplan') && (
                     <div className={`care-nav-item ${isActive('/careplans') ? 'active' : ''}`} onClick={() => handleNavigation('/careplans')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                           <polyline points="14 2 14 8 20 8"></polyline>
                           <line x1="16" y1="13" x2="8" y2="13"></line>
                           <line x1="16" y1="17" x2="8" y2="17"></line>
                        </svg>
                        <span>Care Plans</span>
                     </div>
                  )}

                  {/* Daily Logs */}
                  {hasPermission('DailyLogs') && (
                     <div className={`care-nav-item ${isActive('/daily-logs') ? 'active' : ''}`} onClick={() => handleNavigation('/daily-logs')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d="M16 2v4a2 2 0 0 0 2 2h4"></path>
                           <path d="M3 7V5a2 2 0 0 1 2-2h11l5 5v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2"></path>
                           <path d="M3 12h10"></path>
                           <path d="M7 8L3 12l4 4"></path>
                        </svg>
                        <span>Daily Logs</span>
                     </div>
                  )}

                  {/* Medication & eMAR */}
                  {hasPermission('MedicationEmar') && (
                     <div className={`care-nav-item ${isActive('/medication') ? 'active' : ''}`} onClick={() => handleNavigation('/medication')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6z"></path>
                           <path d="M13.5 10.5H21A7.5 7.5 0 1 0 13.5 3v7.5z"></path>
                        </svg>
                        <span>Medication & eMAR</span>
                     </div>
                  )}

                  {/* Route Planning */}
                  {/* <div
                     className={`care-nav-item ${isActive('/route-planning') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                           <path d="M12 6H12.01M9 20L3 17V4L5 5M9 20L15 17M9 20V14M15 17L21 20V7L19 6M15 17V14M15 6.2C15 7.96731 13.5 9.4 12 11C10.5 9.4 9 7.96731 9 6.2C9 4.43269 10.3431 3 12 3C13.6569 3 15 4.43269 15 6.2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                           </path>
                        </g>
                     </svg>
                     <span>Route Planning<span className='cum-soon'>(Coming Soon)</span></span>
                  </div> */}

                  {/* Outcomes & KPIs */}
                  {hasPermission('Outcomes') && (
                     <div className={`care-nav-item ${isActive('/outcomes') ? 'active' : ''}`} onClick={() => handleNavigation('/outcomes')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <line x1="18" y1="20" x2="18" y2="10"></line>
                           <line x1="12" y1="20" x2="12" y2="4"></line>
                           <line x1="6" y1="20" x2="6" y2="14"></line>
                        </svg>
                        <span>Outcomes & KPIs</span>
                     </div>
                  )}

                  {/* Incidents & Alerts */}
                  {hasPermission('IncidentAlerts') && (
                     <div className={`care-nav-item ${isActive('/incidents') ? 'active' : ''}`} onClick={() => handleNavigation('/incidents')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                           <line x1="12" y1="9" x2="12" y2="13"></line>
                           <line x1="12" y1="17" x2="12.01" y2="17"></line>
                        </svg>
                        <span>Incidents & Alerts</span>
                        {/* <span className="care-nav-badge">3</span> */}
                     </div>
                  )}
               </div>
            )}

            {/* Staff Management Section */}
            {(employeeSubscription === 'active' || showCareSection || setShowallInOne || userRole === 'user') && (
               <div className="care-nav-section">
                  {(hasPermission('Employees') || (showProFeature() && hasPermission('Training')) || hasPermission('Time Sheets')) && (
                     <div className="care-section-header">Staff Management</div>
                  )}
                  {/* Staff Directory */}
                  {(employeeSubscription === 'active' || showCareSection || setShowallInOne || userRole === 'user' && hasPermission('Employees')) && (
                     <div className={`care-nav-item ${isActive('/staff') ? 'active' : ''}`} onClick={() => handleNavigation('/staff')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                           <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span>Staff Directory</span>
                     </div>
                  )}

                  {/* Time Sheets */}
                  {(showCareSection || setShowallInOne || userRole === 'user' && hasPermission('Time Sheets'))   && (
                     <div className={`care-nav-item ${isActive('/timesheet') ? 'active' : ''}`} onClick={() => handleNavigation('/timesheet')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                           <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                           <g id="SVGRepo_iconCarrier">
                              <path
                                 d="M3 5.5L5 3.5M21 5.5L19 3.5M12 8.5V12.5L14 14.5M20 12.5C20 16.9183 16.4183 20.5 12 20.5C7.58172 20.5 4 16.9183 4 12.5C4 8.08172 7.58172 4.5 12 4.5C16.4183 4.5 20 8.08172 20 12.5Z"
                                 stroke="currentColor"
                                 stroke-width="2"
                                 stroke-linecap="round"
                                 stroke-linejoin="round"
                              ></path>
                           </g>
                        </svg>
                        <span>Time Sheets</span>
                     </div>
                  )}

                  {/* Training & Development */}
                  {/* {showProFeature() && hasPermission('Training') && (
                     <div className={`care-nav-item ${isActive('/course') ? 'active' : ''}`} onClick={() => handleNavigation('/course')}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                           <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                        </svg>
                        <span>Training</span>
                     </div>
                  )} */}
               </div>
            )}

            {/* Recruitment */}
            {/* {(showCareSection || setShowallInOne) && hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/recruitment') ? 'active' : ''}`}

                  >

                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier"> <g id="Interface / Search_Magnifying_Glass">
                           <path id="Vector" d="M15 15L21 21M10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                           </path>
                        </g>
                        </g>
                     </svg>
                     <span>Recruitment<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )} */}

            {/* Payroll */}
            {/* {(showCareSection || setShowallInOne) && hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/payroll') ? 'active' : ''}`}

                  >
                     <svg className='care-nav-icon' stroke='currentColor' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                           <path d="M11.7255 17.1019C11.6265 16.8844 11.4215 16.7257 11.1734 16.6975C10.9633 16.6735 10.7576 16.6285 10.562 16.5636C10.4743 16.5341 10.392 16.5019 10.3158 16.4674L10.4424 16.1223C10.5318 16.1622 10.6239 16.1987 10.7182 16.2317L10.7221 16.2331L10.7261 16.2344C11.0287 16.3344 11.3265 16.3851 11.611 16.3851C11.8967 16.3851 12.1038 16.3468 12.2629 16.2647L12.2724 16.2598L12.2817 16.2544C12.5227 16.1161 12.661 15.8784 12.661 15.6021C12.661 15.2955 12.4956 15.041 12.2071 14.9035C12.062 14.8329 11.8559 14.7655 11.559 14.6917C11.2545 14.6147 10.9987 14.533 10.8003 14.4493C10.6553 14.3837 10.5295 14.279 10.4161 14.1293C10.3185 13.9957 10.2691 13.7948 10.2691 13.5319C10.2691 13.2147 10.3584 12.9529 10.5422 12.7315C10.7058 12.5375 10.9381 12.4057 11.2499 12.3318C11.4812 12.277 11.6616 12.1119 11.7427 11.8987C11.8344 12.1148 12.0295 12.2755 12.2723 12.3142C12.4751 12.3465 12.6613 12.398 12.8287 12.4677L12.7122 12.8059C12.3961 12.679 12.085 12.6149 11.7841 12.6149C10.7848 12.6149 10.7342 13.3043 10.7342 13.4425C10.7342 13.7421 10.896 13.9933 11.1781 14.1318L11.186 14.1357L11.194 14.1393C11.3365 14.2029 11.5387 14.2642 11.8305 14.3322C12.1322 14.4004 12.3838 14.4785 12.5815 14.5651L12.5856 14.5669L12.5897 14.5686C12.7365 14.6297 12.8624 14.7317 12.9746 14.8805L12.9764 14.8828L12.9782 14.8852C13.0763 15.012 13.1261 15.2081 13.1261 15.4681C13.1261 15.7682 13.0392 16.0222 12.8604 16.2447C12.7053 16.4377 12.4888 16.5713 12.1983 16.6531C11.974 16.7163 11.8 16.8878 11.7255 17.1019Z" fill="#000000"></path> <path d="M11.9785 18H11.497C11.3893 18 11.302 17.9105 11.302 17.8V17.3985C11.302 17.2929 11.2219 17.2061 11.1195 17.1944C10.8757 17.1667 10.6399 17.115 10.412 17.0394C10.1906 16.9648 9.99879 16.8764 9.83657 16.7739C9.76202 16.7268 9.7349 16.6312 9.76572 16.5472L10.096 15.6466C10.1405 15.5254 10.284 15.479 10.3945 15.5417C10.5437 15.6262 10.7041 15.6985 10.8755 15.7585C11.131 15.8429 11.3762 15.8851 11.611 15.8851C11.8129 15.8851 11.9572 15.8628 12.0437 15.8181C12.1302 15.7684 12.1735 15.6964 12.1735 15.6021C12.1735 15.4929 12.1158 15.411 12.0004 15.3564C11.8892 15.3018 11.7037 15.2422 11.4442 15.1777C11.1104 15.0933 10.8323 15.0039 10.6098 14.9096C10.3873 14.8103 10.1936 14.6514 10.0288 14.433C9.86396 14.2096 9.78156 13.9092 9.78156 13.5319C9.78156 13.095 9.91136 12.7202 10.1709 12.4074C10.4049 12.13 10.7279 11.9424 11.1401 11.8447C11.2329 11.8227 11.302 11.7401 11.302 11.6425V11.2C11.302 11.0895 11.3893 11 11.497 11H11.9785C12.0862 11 12.1735 11.0895 12.1735 11.2V11.6172C12.1735 11.7194 12.2487 11.8045 12.3471 11.8202C12.7082 11.8777 13.0255 11.9866 13.2989 12.1469C13.3765 12.1924 13.4073 12.2892 13.3775 12.3756L13.0684 13.2725C13.0275 13.3914 12.891 13.4417 12.7812 13.3849C12.433 13.2049 12.1007 13.1149 11.7841 13.1149C11.4091 13.1149 11.2216 13.2241 11.2216 13.4425C11.2216 13.5468 11.2773 13.6262 11.3885 13.6809C11.4998 13.7305 11.6831 13.7851 11.9386 13.8447C12.2682 13.9192 12.5464 14.006 12.773 14.1053C12.9996 14.1996 13.1953 14.356 13.3602 14.5745C13.5291 14.7929 13.6136 15.0908 13.6136 15.4681C13.6136 15.8851 13.4879 16.25 13.2365 16.5628C13.0176 16.8354 12.7145 17.0262 12.3274 17.1353C12.2384 17.1604 12.1735 17.2412 12.1735 17.3358V17.8C12.1735 17.9105 12.0862 18 11.9785 18Z" fill="#000000"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.59235 5H13.8141C14.8954 5 14.3016 6.664 13.8638 7.679L13.3656 8.843L13.2983 9C13.7702 8.97651 14.2369 9.11054 14.6282 9.382C16.0921 10.7558 17.2802 12.4098 18.1256 14.251C18.455 14.9318 18.5857 15.6958 18.5019 16.451C18.4013 18.3759 16.8956 19.9098 15.0182 20H8.38823C6.51033 19.9125 5.0024 18.3802 4.89968 16.455C4.81587 15.6998 4.94656 14.9358 5.27603 14.255C6.12242 12.412 7.31216 10.7565 8.77823 9.382C9.1696 9.11054 9.63622 8.97651 10.1081 9L10.0301 8.819L9.54263 7.679C9.1068 6.664 8.5101 5 9.59235 5Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.2983 9.75C13.7125 9.75 14.0483 9.41421 14.0483 9C14.0483 8.58579 13.7125 8.25 13.2983 8.25V9.75ZM10.1081 8.25C9.69391 8.25 9.35812 8.58579 9.35812 9C9.35812 9.41421 9.69391 9.75 10.1081 9.75V8.25ZM15.9776 8.64988C16.3365 8.44312 16.4599 7.98455 16.2531 7.62563C16.0463 7.26671 15.5878 7.14336 15.2289 7.35012L15.9776 8.64988ZM13.3656 8.843L13.5103 9.57891L13.5125 9.57848L13.3656 8.843ZM10.0301 8.819L10.1854 8.08521L10.1786 8.08383L10.0301 8.819ZM8.166 7.34357C7.80346 7.14322 7.34715 7.27469 7.1468 7.63722C6.94644 7.99976 7.07791 8.45607 7.44045 8.65643L8.166 7.34357ZM13.2983 8.25H10.1081V9.75H13.2983V8.25ZM15.2289 7.35012C14.6019 7.71128 13.9233 7.96683 13.2187 8.10752L13.5125 9.57848C14.3778 9.40568 15.2101 9.09203 15.9776 8.64988L15.2289 7.35012ZM13.2209 8.10709C12.2175 8.30441 11.1861 8.29699 10.1854 8.08525L9.87486 9.55275C11.0732 9.80631 12.3086 9.81521 13.5103 9.57891L13.2209 8.10709ZM10.1786 8.08383C9.47587 7.94196 8.79745 7.69255 8.166 7.34357L7.44045 8.65643C8.20526 9.0791 9.02818 9.38184 9.88169 9.55417L10.1786 8.08383Z" fill="#000000">
                           </path>
                        </g>
                     </svg>
                     <span>Payroll<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )} */}

            {/* Supervision */}
            {/* {(showCareSection || setShowallInOne) && hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/supervision') ? 'active' : ''}`}

                  >
                     <svg className='care-nav-icon' stroke='currentColor' fill="none" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>eye</title> <path d="M0 16q0.064 0.128 0.16 0.352t0.48 0.928 0.832 1.344 1.248 1.536 1.664 1.696 2.144 1.568 2.624 1.344 3.136 0.896 3.712 0.352 3.712-0.352 3.168-0.928 2.592-1.312 2.144-1.6 1.664-1.632 1.248-1.6 0.832-1.312 0.48-0.928l0.16-0.352q-0.032-0.128-0.16-0.352t-0.48-0.896-0.832-1.344-1.248-1.568-1.664-1.664-2.144-1.568-2.624-1.344-3.136-0.896-3.712-0.352-3.712 0.352-3.168 0.896-2.592 1.344-2.144 1.568-1.664 1.664-1.248 1.568-0.832 1.344-0.48 0.928zM10.016 16q0-2.464 1.728-4.224t4.256-1.76 4.256 1.76 1.76 4.224-1.76 4.256-4.256 1.76-4.256-1.76-1.728-4.256zM12 16q0 1.664 1.184 2.848t2.816 1.152 2.816-1.152 1.184-2.848-1.184-2.816-2.816-1.184-2.816 1.184l2.816 2.816h-4z"></path> </g></svg>
                     <span>Supervision<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )} */}

            {/* Compliance & DBS */}
            {/* {(showCareSection || setShowallInOne) && hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/compliance') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                     <span>Compliance & DBS<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )} */}

            {/* Documents & Compliance Section */}
            {/* {(showCareSection === false || userRole === 'user') && (
               <>
                  <div className="care-nav-section">
                     <>
                        {(hasPermission('Documents') || hasPermission('My Documents') || hasPermission('DocuSign') || hasPermission('Policies') || hasPermission('Forms') || hasPermission('Index') || hasPermission('Index') || hasPermission('hasPermission')) &&
                           <>
                              <div className="care-section-header">Documents & Compliance</div>
                              <button className={`care-nav-item ${expandedMenus.documents ? 'expanded' : ''}`} onClick={() => toggleSubmenu('documents')}>
                                 <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                                    <polyline points="13 2 13 9 20 9"></polyline>
                                 </svg>
                                 <span>Documents</span>
                                 <svg className="care-expand-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                 </svg>
                              </button>
                           </>
                        }

                        <div className={`care-sub-menu ${expandedMenus.documents ? 'expanded' : ''}`}>
                           {hasPermission('Documents') &&

                              <div className={`care-sub-nav-item ${isActive('/documents') ? 'active' : ''}`} onClick={() => handleNavigation('/documents')}>
                                 <span>Policies & Procedures</span>
                              </div>
                           }
                           {hasPermission('My Documents') &&
                              <div className={`care-sub-nav-item ${isActive('/myDocuments') ? 'active' : ''}`} onClick={() => handleNavigation('/myDocuments')}>
                                 <span>My Documents</span>
                              </div>
                           }

                           {(showProFeature() || hasPermission('DocuSign')) && (
                              <div className={`care-sub-nav-item ${isActive('/myfiles') ? 'active' : ''}`} onClick={() => handleNavigation('/myfiles')}>
                                 <span>DocuSign</span>
                              </div>
                           )}
                           {hasPermission('Policies') &&
                              <div className={`care-sub-nav-item ${isActive('/policies') ? 'active' : ''}`} onClick={() => handleNavigation('/policies')}>
                                 <span>Staff Policies</span>
                              </div>
                           }
                           {showPublicPolicies() === true && (
                              <div
                                 className={`care-sub-nav-item ${isActive('/publishedpolicies') ? 'active' : ''}`}
                                 onClick={() => handleNavigation('/publishedpolicies')}
                              >
                                 <span>Public Policies</span>
                              </div>
                           )}
                           {(showProFeature() || hasPermission('Forms')) && (
                              <div className={`care-sub-nav-item ${isActive('/formslist') ? 'active' : ''}`} onClick={() => handleNavigation('/formslist')}>
                                 <span>Forms</span>
                              </div>
                           )}
                           {hasPermission('Index') &&
                              <div className={`care-sub-nav-item ${isActive('/index') ? 'active' : ''}`} onClick={() => handleNavigation('/index')}>
                                 <span>Index</span>
                              </div>
                           }
                           {hasPermission('deleted-documents') &&
                              <div
                                 className={`care-sub-nav-item ${isActive('/deleted-documents') ? 'active' : ''}`}
                                 onClick={() => handleNavigation('/deleted-documents')}
                              >
                                 <span>Bin</span>
                              </div>
                           }

                        </div>
                     </>
                  </div>
               </>
            )} */}
{(userHavelicense === true || userRole === 'user' || employeeSubscription) && (
   <>
      <div className="care-nav-section">
            <div className="care-section-header">Documents & Compliance</div>

         {(userHavelicense ||( userRole === 'user' && hasPermission('Documents'))) && (
            <div className={`care-nav-item ${isActive('/documents') ? 'active' : ''}`} onClick={() => handleNavigation('/documents')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                  <polyline points="13 2 13 9 20 9"></polyline>
               </svg>
               <span>Policies & Procedures</span>
            </div>
         )}

         {(userHavelicense || (userRole === 'user' && hasPermission('My Documents')) )&& (
            <div className={`care-nav-item ${isActive('/myDocuments') ? 'active' : ''}`} onClick={() => handleNavigation('/myDocuments')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
               </svg>
               <span>My Documents</span>
            </div>
         )}

         {(showProFeature()  || (userRole === 'user' && hasPermission('DocuSign'))) && (
            <div className={`care-nav-item ${isActive('/myfiles') ? 'active' : ''}`} onClick={() => handleNavigation('/myfiles')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
               </svg>
               <span>DocuSign</span>
            </div>
         )}

         {(employeeSubscription || (userRole === 'user' && hasPermission('Policies'))) && (
            <div className={`care-nav-item ${isActive('/policies') ? 'active' : ''}`} onClick={() => handleNavigation('/policies')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
               </svg>
               <span>Staff Policies</span>
            </div>
         )}

         {showPublicPolicies() === true && (
            <div className={`care-nav-item ${isActive('/publishedpolicies') ? 'active' : ''}`} onClick={() => handleNavigation('/publishedpolicies')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="2" y1="12" x2="22" y2="12"></line>
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
               </svg>
               <span>Public Policies</span>
            </div>
         )}

         {(showProFeature()  ||  (userRole === 'user' && hasPermission('Forms'))) && (
            <div className={`care-nav-item ${isActive('/formslist') ? 'active' : ''}`} onClick={() => handleNavigation('/formslist')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 11l3 3L22 4"></path>
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
               </svg>
               <span>Forms</span>
            </div>
         )}

         {(userHavelicense || (userRole === 'user' && hasPermission('Index'))) && (
            <div className={`care-nav-item ${isActive('/index') ? 'active' : ''}`} onClick={() => handleNavigation('/index')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
               </svg>
               <span>Index</span>
            </div>
         )}

         {/* {(userHavelicense || (userRole === 'user' && hasPermission('deleted-documents'))) && (
            <div className={`care-nav-item ${isActive('/deleted-documents') ? 'active' : ''}`} onClick={() => handleNavigation('/deleted-documents')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
               </svg>
               <span>Bin</span>
            </div>
         )} */}
      </div>
   </>
)}
            {/* FINANCIAL MANAGEMENT */}

            {/* <div className="care-nav-section">
               <div className="care-section-header">FINANCIAL MANAGEMENT</div>

      
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/billing') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="9" y1="17" x2="9" y2="9"></line>
                        <line x1="15" y1="17" x2="15" y2="12"></line>
                        <line x1="12" y1="17" x2="12" y2="6"></line>
                        <line x1="6" y1="17" x2="6" y2="14"></line>
                        <line x1="18" y1="17" x2="18" y2="10"></line>
                     </svg>

                     <span>Billing & Invoicing<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

               
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/financial-reports') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="9" y1="17" x2="9" y2="9"></line>
                        <line x1="15" y1="17" x2="15" y2="12"></line>
                        <line x1="12" y1="17" x2="12" y2="6"></line>
                        <line x1="6" y1="17" x2="6" y2="14"></line>
                        <line x1="18" y1="17" x2="18" y2="10"></line>
                     </svg>
                     <span>Financial Reports<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

     
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/payments') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="7"></circle>
                        <path d="M12 8v8"></path>
                        <path d="M9.5 10.5c0-1 .5-1.5 2.5-1.5s2.5 0.5 2.5 1.5c0 1-0.5 1.5-2.5 1.5s-2.5 0.5-2.5 1.5c0 1 0.5 1.5 2.5 1.5s2.5-0.5 2.5-1.5"></path>
                        <path d="M3 12l-2-2v3l2 2"></path>
                        <path d="M21 12l2-2v3l-2 2"></path>
                        <path d="M3 9l-2-2"></path>
                        <path d="M21 9l2-2"></path>
                     </svg>
                     <span>Payments & Collections<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

              
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/budgets') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 3v18h18"></path>
                        <polyline points="7 17 11 13 15 15 21 9"></polyline>
                        <polyline points="17 9 21 9 21 13"></polyline>
                     </svg>
                     <span>Budgets & Forecasting<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

          
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/expense') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z"></path>
                        <line x1="9" y1="7" x2="15" y2="7"></line>
                        <line x1="9" y1="11" x2="15" y2="11"></line>
                        <line x1="9" y1="15" x2="13" y2="15"></line>
                     </svg>
                     <span>Expense Management<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

          
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/contracts') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                        <line x1="9" y1="12" x2="15" y2="12"></line>
                        <line x1="9" y1="16" x2="13" y2="16"></line>
                     </svg>
                     <span>Contracts<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}
            </div> */}

            {/* Communication Section */}

            {/* <div className="care-nav-section">
               <div className="care-section-header">COMMUNICATION</div>

            
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/messages') ? 'active' : ''}`}

                  >
                     <svg className='care-nav-icon' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                     <span>Messages<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

         
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/announcements') ? 'active' : ''}`}

                  >
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 9C16.5 9.5 17 10.5 17 12C17 13.5 16.5 14.5 16 15M19 6C20.5 7.5 21 10 21 12C21 14 20.5 16.5 19 18M13 3L7 8H5C3.89543 8 3 8.89543 3 10V14C3 15.1046 3.89543 16 5 16H7L13 21V3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                     <span>Announcements<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

          
               {hasPermission('Employees') && (
                  <div
                     className={`care-nav-item ${isActive('/notifications') ? 'active' : ''}`}
                  >

                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 9C16.5 9.5 17 10.5 17 12C17 13.5 16.5 14.5 16 15M19 6C20.5 7.5 21 10 21 12C21 14 20.5 16.5 19 18M13 3L7 8H5C3.89543 8 3 8.89543 3 10V14C3 15.1046 3.89543 16 5 16H7L13 21V3Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                     <span>Notifications<span className='cum-soon'>(Coming Soon)</span></span>
                  </div>
               )}

            </div> */}



            <div className="care-nav-section care-nav-section-bottom">
               {(hasPermission('Users') || hasPermission('Subscriptions') || hasPermission('Settings')) &&
                  <div className="care-section-header">Organisation</div>
               }

               {/* System Users */}
               {hasPermission('Users') && (
                  <div className={`care-nav-item ${isActive('/users') ? 'active' : ''}`} onClick={() => handleNavigation('/users')}>
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="8.5" cy="7" r="4"></circle>
                        <line x1="20" y1="8" x2="20" y2="14"></line>
                        <line x1="23" y1="11" x2="17" y2="11"></line>
                     </svg>
                     <span>System Users</span>
                  </div>
               )}

               {/* Subscription */}
               {(userRole === 'company' || hasPermission('Subscriptions')) && (
                  <div className={`care-nav-item ${isActive('/subscriptions') ? 'active' : ''}`} onClick={() => handleNavigation('/subscriptions')}>
                     <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                        <line x1="1" y1="10" x2="23" y2="10"></line>
                     </svg>
                     <span>Subscription</span>
                  </div>
               )}

               {/* Settings with dropdown */}
               <div className="care-settings-dropdown">
                  {hasPermission('Settings') &&
                     <button className={`care-nav-item ${isSettingsOpen ? 'active' : ''}`} onClick={() => setIsSettingsOpen(!isSettingsOpen)}>
                        <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                           <circle cx="12" cy="12" r="3"></circle>
                           <path d="M12 1v6m0 6v6m4.22-10.22l4.24 4.24M6.34 6.34L2.1 2.1m17.8 17.8l-4.24-4.24M6.34 17.66L2.1 21.9"></path>
                        </svg>
                        <span>Settings</span>
                     </button>
                  }
                  {isSettingsOpen && (
                     <div className="care-settings-menu">
                        <div className="care-settings-item" onClick={() => myProfilefun('companydetail')}>
                           Organisation Details
                        </div>
                        <div className="care-settings-item" onClick={company_settings}>
                           {userRole === 'user' ? 'Other Settings' : 'System Settings'}
                        </div>
                     </div>
                  )}
               </div>

               {(userHavelicense || (userRole === 'user' && hasPermission('deleted-documents'))) && (
            <div className={`care-nav-item ${isActive('/deleted-documents') ? 'active' : ''}`} onClick={() => handleNavigation('/deleted-documents')}>
               <svg className="care-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
               </svg>
               <span>Bin</span>
            </div>
         )}
            </div>
         </div>

         {/* Training Button */}
         {showTrainingButton() && (
            <button className="care-training-btn" onClick={openTraining}>
               <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                  <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
               </svg>
               <span>Book Training</span>
            </button>
         )}

         {/* User Profile */}
         {/* <div className="care-user-profile">
            <div className="care-user-avatar">{getUserInitials()}</div>
            <div className="care-user-info" onClick={() => setDropdownOpen(true)}>
               <div className="care-user-name">{userDetails?.firstname || 'User'}</div>
            </div>
            {dropdownOpen && (
               <div>
                  <div className="list_items" onClick={() => myProfilefun('myprofile')}>
                     My Profile
                  </div>

                  {String(active_subs) !== String(false) &&
                     docUpdateStatus === 'active' &&
                     licenseStatus === 'active' && (
                        <div className="list_items" onClick={restore_modal_view}>
                           Restore All
                        </div>
                     )}
                  <div className="logout-menu" onClick={() => dispatch(logOut(history))}>
                     Logout
                  </div>
               </div>
            )}

         </div> */}

         <Dropdown isOpen={dropdownOpen} toggle={profileToggle} className="profile-dropdown-sidebar">
            <DropdownToggle tag="div" className="care-user-profile-toggle" data-toggle={dropdownOpen}>
               <div className="care-user-avatar">{getUserInitials()}</div>
               <div className="care-user-info">
                  <div className="care-user-name">{userDetails?.firstname || 'User'}</div>
               </div>
            </DropdownToggle>

            {/* {dropdownOpen && (
               <DropdownMenu className="care-profile-dropdown-menu-sidebar">
                  <div className="inner_head_sec">
                     <div className="inner_heads">
                        <div className="cancel_headsec">
                           <span className="drop-profile">
                              <div className="profile-img">{getUserInitials()}</div>
                              <span className="drop-user">
                                 <span>{getLongName()}</span>
                                 <span className="drop-email">{userDetails?.email || ''}</span>
                              </span>
                           </span>

                           <div className='drop-list'>
                              <div className="list_items" onClick={() => myProfilefun('myprofile')}>
                                 My Profile
                              </div>

                              {String(active_subs) !== String(false) &&
                                 docUpdateStatus === 'active' &&
                                 licenseStatus === 'active' && (
                                    <div className="list_items" onClick={restore_modal_view}>
                                       Restore All
                                    </div>
                                 )}

                              <div className="logout-menu" onClick={() => dispatch(logOut(history))}>
                                 Logout
                              </div>
                           </div>



                        </div>
                     </div>
                  </div>
               </DropdownMenu>
            )} */}

            {dropdownOpen && (
               <div style={{ bottom: 0 }} className="care-profile-dropdown-menu-sidebar">
                  {/* <div className="inner_head_sec_dropdown">
                     <div className="inner_heads">
                        <div className="cancel_headsec"> */}
                  {/* <span className="drop-profile">
                              <div className="profile-img">{getUserInitials()}</div>
                              <span className="drop-user">
                                 <span>{getLongName()}</span>
                                 <span className="drop-email">{userDetails?.email || ''}</span>
                              </span>
                           </span> */}

                  <div className="drop-list">
                     <div className="list_items" onClick={(e) => myProfilefun('myprofile')}>
                        My Profile
                     </div>

                     {/* {String(active_subs) !== String(false) &&
                        docUpdateStatus === 'active' &&
                        licenseStatus === 'active' && (
                           <div className="list_items" onClick={() => restore_modal_view()}>
                                    Restore All
                                 </div>
                        )} */}
                     {String(active_subs) !== String(false) && docUpdateStatus === 'active' && licenseStatus && licenseStatus === 'active' ? (
                        <div className="list_items" onClick={() => restore_modal_view()}>
                           Restore All
                        </div>
                     ) : null}

                     <div className="logout-menu" onClick={() => dispatch(logOut(props.history))}>
                        Logout
                     </div>
                  </div>
               </div>
               //       </div>
               //    </div>
               // </div>
            )}
         </Dropdown>
      </nav>
   );
};

export default CareSidebar;
